"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgPencilLine = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.293 2.293a3.829 3.829 0 0 1 5.414 5.414L10.391 19.023c-.234.234-.41.41-.61.566a4.006 4.006 0 0 1-.56.364c-.223.12-.456.209-.764.327l-.125.048-.093.036-5.38 2.07a1 1 0 0 1-1.292-1.293l2.153-5.598c.118-.308.208-.541.327-.764a4 4 0 0 1 .364-.56c.155-.2.332-.376.565-.61L16.293 2.293ZM5.38 16.795l-1.14 2.964 2.964-1.14-1.824-1.824Z", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { d: "M13 20h8a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2Z", fill: "currentColor" })] }))); };
exports.default = SvgPencilLine;
